export default {
  GET_DATA: 'GET_DATA',
};
